<template>
  <row class="contragents-list" :gutter="16" type="flex" align="top">
    <i-col span="24" v-for="contragent in contragents" :key="contragent.id">
      <contragents-item :contragent="contragent" />
    </i-col>
  </row>
</template>

<script>
import ContragentsItem from './contragents-item'

export default {
  components: {
    ContragentsItem
  },
  props: ['contragents']
}
</script>

<style>
</style>
